query GetReportId($id: String) {
  company(id: $id) {
    id
    googlePerformanceReportId
  }
}
